import React from 'react';
import PropTypes from 'prop-types';

import makeStyles from '@material-ui/core/styles/makeStyles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import FormGroup from '@material-ui/core/FormGroup';

import CheckboxButton from 'components/buttons/CheckboxButton';

const useStyles = makeStyles({
  formGroup: {
    maxWidth: '260px',
    marginLeft: '25px'
  },
  formTitle: {
    textTransform: 'uppercase',
    marginLeft: '-12px',
    fontWeight: '600'
  },
  formButton: {
    marginLeft: '-12px',
    marginTop: '16px'
  }
});

const ColumnVisibilityMenu = ({ onSubmit, register, handleClose, tableColumnsState }) => {
  const classes = useStyles();

  return (
    <form onSubmit={onSubmit}>
      <FormGroup className={classes.formGroup}>
        <Typography variant="subtitle2" gutterBottom className={classes.formTitle}>
          Table Columns
        </Typography>
        <Grid container direction="row" justify="flex-start" alignItems="flex-start">
          <Grid item xs={12} md={12}>
            {tableColumnsState.length > 0 &&
              tableColumnsState.map(col => (
                <CheckboxButton
                  key={col.label}
                  title={col.label}
                  name={col.label}
                  checked={col.options.display}
                  inputRef={register}
                />
              ))}
          </Grid>

          <Grid item xs={5}>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              className={classes.formButton}
            >
              Save
            </Button>
          </Grid>
          <Grid item xs={5}>
            <Button color="primary" onClick={handleClose} className={classes.formButton}>
              Cancel
            </Button>
          </Grid>
        </Grid>
      </FormGroup>
    </form>
  );
};

ColumnVisibilityMenu.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  register: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  tableColumnsState: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      options: PropTypes.shape({})
    })
  ).isRequired
};

export default ColumnVisibilityMenu;
